import React, { useMemo } from 'react';
import arrowCircleIconSrc, { ReactComponent as ArrowCircleSvg } from 'assets/icons/new/arrow-circle.svg';
import bookIconSrc, { ReactComponent as BookSvg } from 'assets/icons/new/book.svg';
import brandLinkedinIconSrc, { ReactComponent as BrandLinkedinSvg } from 'assets/icons/new/brand-linkedin.svg';
import bulbElectroIconSrc, { ReactComponent as BulbElectroSvg } from 'assets/icons/new/bulb-electro.svg';
import bulletIconSrc, { ReactComponent as BulletSvg } from 'assets/icons/new/bullet.svg';
import calendarDateIconSrc, { ReactComponent as CalendarDateSvg } from 'assets/icons/new/calendar-date.svg';
import calendarScheduleIconSrc, { ReactComponent as CalendarScheduleSvg } from 'assets/icons/new/calendar-schedule.svg';
import calendarMagnifyingGlassIconSrc, {
	ReactComponent as CalendarMagnifyingGlassSvg,
} from 'assets/icons/new/calendar-magnifying-glass.svg';
import calendarFullIconSrc, { ReactComponent as CalendarFullSvg } from 'assets/icons/new/calendar-full.svg';
import checkSquareIconSrc, { ReactComponent as CheckSquareSvg } from 'assets/icons/new/check-square.svg';
import checklistIconSrc, { ReactComponent as ChecklistSvg } from 'assets/icons/new/checklist.svg';
import cloudMessageZigzagIconSrc, {
	ReactComponent as CloudMessageZigzagIcon,
} from 'assets/icons/new/cloud-message-zigzag.svg';
import clockIconSrc, { ReactComponent as ClockSvg } from 'assets/icons/new/clock.svg';
import communicationIconSrc, { ReactComponent as CommunicationSvg } from 'assets/icons/new/communication.svg';
import contactIconSrc, { ReactComponent as ContactSvg } from 'assets/icons/new/contact.svg';
import desktopIconSrc, { ReactComponent as DesktopSvg } from 'assets/icons/new/desktop.svg';
import downloadIconSrc, { ReactComponent as DownloadSvg } from 'assets/icons/new/download.svg';
import diagramSquareIconSrc, { ReactComponent as DiagramSquareSvg } from 'assets/icons/new/diagram-square.svg';
import envelopeIconSrc, { ReactComponent as EnvelopeSvg } from 'assets/icons/new/envelope.svg';
import eyeAltIconSrc, { ReactComponent as EyeAltSvg } from 'assets/icons/new/eye-alt.svg';
import eyeIconSrc, { ReactComponent as EyeSvg } from 'assets/icons/new/eye.svg';
import fileCheckIconSrc, { ReactComponent as FileCheckSvg } from 'assets/icons/new/file-check.svg';
import checklistSquareAltIconSrc, {
	ReactComponent as ChecklistSquareAltSvg,
} from 'assets/icons/new/checklist-square-alt.svg';
import checklistSquareIconSrc, { ReactComponent as ChecklistSquareSvg } from 'assets/icons/new/checklist-square.svg';
import goalsEvaluationIconSrc, { ReactComponent as GoalsEvaluationSvg } from 'assets/icons/new/goals-evaluation.svg';
import editSquareIconSrc, { ReactComponent as EditSquareSvg } from 'assets/icons/new/edit-square.svg';
import openExternalIconSrc, { ReactComponent as OpenExternalSvg } from 'assets/icons/new/open-external.svg';
import notFoundSquareIconSrc, { ReactComponent as NotFoundSquareSvg } from 'assets/icons/new/not-found-square.svg';
import pdfSquareIconSrc, { ReactComponent as PdfSquareSvg } from 'assets/icons/new/pdf-square.svg';
import pencilSignSquareIconSrc, {
	ReactComponent as PencilSignSquareSvg,
} from 'assets/icons/new/pencil-sign-square.svg';
import pencilSquareIconSrc, { ReactComponent as PencilSquareSvg } from 'assets/icons/new/pencil-square.svg';
import textWriteSquareIconSrc, { ReactComponent as TextWriteSquareSvg } from 'assets/icons/new/text-write-square.svg';
import textSquareIconSrc, { ReactComponent as TextSquareSvg } from 'assets/icons/new/text-square.svg';
import handIconSrc, { ReactComponent as HandSvg } from 'assets/icons/new/hand.svg';
import heartIconSrc, { ReactComponent as HeartSvg } from 'assets/icons/new/heart.svg';
import homeIconSrc, { ReactComponent as HomeSvg } from 'assets/icons/new/home.svg';
import identifierIconSrc, { ReactComponent as IdentifierSvg } from 'assets/icons/new/identifier.svg';
import papersIconSrc, { ReactComponent as PapersSvg } from 'assets/icons/new/papers.svg';
import pathIconSrc, { ReactComponent as PathSvg } from 'assets/icons/new/path.svg';
import phoneIconSrc, { ReactComponent as PhoneSvg } from 'assets/icons/new/phone.svg';
import bulbElectroSquareIconSrc, {
	ReactComponent as BulbElectroSquareSvg,
} from 'assets/icons/new/bulb-electro-square.svg';
import questionMarkSquareIconSrc, {
	ReactComponent as QuestionMarkSquareSvg,
} from 'assets/icons/new/question-mark-square.svg';
import questionMarkSquareAltIconSrc, {
	ReactComponent as QuestionMarkSquareAltSvg,
} from 'assets/icons/new/question-mark-square-alt.svg';
import settingsIconSrc, { ReactComponent as SettingsSvg } from 'assets/icons/new/settings.svg';
import sheetIconSrc, { ReactComponent as SheetSvg } from 'assets/icons/new/sheet.svg';
import bookSquareIconSrc, { ReactComponent as BookSquareSvg } from 'assets/icons/new/book-square.svg';
import bookMagSquareIconSrc, { ReactComponent as BookMagSquareSvg } from 'assets/icons/new/book-mag-square.svg';
import compasSquareIconSrc, { ReactComponent as CompasSquareSvg } from 'assets/icons/new/compas-square.svg';
import faceSadSquareIconSrc, { ReactComponent as FaceSadSquareSvg } from 'assets/icons/new/face-sad-square.svg';
import rocketSquareIconSrc, { ReactComponent as RocketSquareSvg } from 'assets/icons/new/rocket-square.svg';
import signpostSquareIconSrc, { ReactComponent as SignpostSquareSvg } from 'assets/icons/new/signpost-square.svg';
import sproutSquareIconSrc, { ReactComponent as SproutSquareSvg } from 'assets/icons/new/sprout-square.svg';
import starIconSrc, { ReactComponent as StarSvg } from 'assets/icons/new/star.svg';
import statsIconSrc, { ReactComponent as StatsSvg } from 'assets/icons/new/stats.svg';
import toolsIconSrc, { ReactComponent as ToolsSvg } from 'assets/icons/new/tools.svg';
import timesSquareIconSrc, { ReactComponent as TimesSquareSvg } from 'assets/icons/new/times-square.svg';
import trashIconSrc, { ReactComponent as TrashSvg } from 'assets/icons/new/trash.svg';
import userPlusIconSrc, { ReactComponent as UserPlusSvg } from 'assets/icons/new/user-plus.svg';
import userIconSrc, { ReactComponent as UserSvg } from 'assets/icons/new/user.svg';
import usersIconSrc, { ReactComponent as UsersSvg } from 'assets/icons/new/users.svg';
import videoIconSrc, { ReactComponent as VideoSvg } from 'assets/icons/new/video.svg';

export type IconName =
	| 'arrow-circle'
	| 'book'
	| 'brand-linkedin'
	| 'bulb-electro'
	| 'bullet'
	| 'calendar-date'
	| 'calendar-schedule'
	| 'calendar-magnifying-glass'
	| 'calendar-full'
	| 'check-square'
	| 'checklist'
	| 'cloud-message-zigzag'
	| 'clock'
	| 'contract-panel'
	| 'communication'
	| 'contact'
	| 'desktop'
	| 'download'
	| 'diagram-square'
	| 'envelope'
	| 'eye-alt'
	| 'eye'
	| 'file-check'
	| 'checklist-square-alt'
	| 'checklist-square'
	| 'goals-evaluation'
	| 'edit-square'
	| 'open-external'
	| 'not-found-square'
	| 'pdf-square'
	| 'pencil-sign-square'
	| 'pencil-square'
	| 'text-write-square'
	| 'text-square'
	| 'first-steps'
	| 'hand'
	| 'heart'
	| 'home'
	| 'identifier'
	| 'papers'
	| 'path'
	| 'phone'
	| 'preparatory-forms'
	| 'question-mark-square'
	| 'question-mark-square-alt'
	| 'settings'
	| 'sheet'
	| 'book-square'
	| 'book-mag-square'
	| 'bulb-electro-square'
	| 'compas-square'
	| 'face-sad-square'
	| 'rocket-square'
	| 'signpost-square'
	| 'sprout-square'
	| 'star'
	| 'stats'
	| 'times-square'
	| 'tools'
	| 'trash'
	| 'user-plus'
	| 'user'
	| 'users'
	| 'video';

export type IconSvgProps = React.SVGProps<SVGSVGElement> & {
	name: IconName;
	size?: number | [number, number];
	className?: string;
};

export const IconSvg = ({ name, size, className, ...props }: IconSvgProps) => {
	const Component = useMemo(() => {
		switch (name) {
			case 'arrow-circle':
				return ArrowCircleSvg;
			case 'book':
				return BookSvg;
			case 'brand-linkedin':
				return BrandLinkedinSvg;
			case 'bulb-electro':
				return BulbElectroSvg;
			case 'bullet':
				return BulletSvg;
			case 'calendar-date':
				return CalendarDateSvg;
			case 'calendar-schedule':
				return CalendarScheduleSvg;
			case 'calendar-magnifying-glass':
				return CalendarMagnifyingGlassSvg;
			case 'calendar-full':
				return CalendarFullSvg;
			case 'check-square':
				return CheckSquareSvg;
			case 'checklist':
				return ChecklistSvg;
			case 'cloud-message-zigzag':
				return CloudMessageZigzagIcon;
			case 'clock':
				return ClockSvg;
			case 'communication':
				return CommunicationSvg;
			case 'contact':
				return ContactSvg;
			case 'desktop':
				return DesktopSvg;
			case 'download':
				return DownloadSvg;
			case 'diagram-square':
				return DiagramSquareSvg;
			case 'envelope':
				return EnvelopeSvg;
			case 'eye-alt':
				return EyeAltSvg;
			case 'eye':
				return EyeSvg;
			case 'file-check':
				return FileCheckSvg;
			case 'checklist-square-alt':
				return ChecklistSquareAltSvg;
			case 'checklist-square':
				return ChecklistSquareSvg;
			case 'goals-evaluation':
				return GoalsEvaluationSvg;
			case 'edit-square':
				return EditSquareSvg;
			case 'open-external':
				return OpenExternalSvg;
			case 'not-found-square':
				return NotFoundSquareSvg;
			case 'pdf-square':
				return PdfSquareSvg;
			case 'pencil-sign-square':
				return PencilSignSquareSvg;
			case 'pencil-square':
				return PencilSquareSvg;
			case 'text-write-square':
				return TextWriteSquareSvg;
			case 'text-square':
				return TextSquareSvg;
			case 'hand':
				return HandSvg;
			case 'heart':
				return HeartSvg;
			case 'home':
				return HomeSvg;
			case 'identifier':
				return IdentifierSvg;
			case 'papers':
				return PapersSvg;
			case 'path':
				return PathSvg;
			case 'phone':
				return PhoneSvg;
			case 'question-mark-square':
				return QuestionMarkSquareSvg;
			case 'question-mark-square-alt':
				return QuestionMarkSquareAltSvg;
			case 'settings':
				return SettingsSvg;
			case 'sheet':
				return SheetSvg;
			case 'book-square':
				return BookSquareSvg;
			case 'book-mag-square':
				return BookMagSquareSvg;
			case 'bulb-electro-square':
				return BulbElectroSquareSvg;
			case 'compas-square':
				return CompasSquareSvg;
			case 'face-sad-square':
				return FaceSadSquareSvg;
			case 'rocket-square':
				return RocketSquareSvg;
			case 'signpost-square':
				return SignpostSquareSvg;
			case 'sprout-square':
				return SproutSquareSvg;
			case 'star':
				return StarSvg;
			case 'stats':
				return StatsSvg;
			case 'times-square':
				return TimesSquareSvg;
			case 'tools':
				return ToolsSvg;
			case 'trash':
				return TrashSvg;
			case 'user-plus':
				return UserPlusSvg;
			case 'user':
				return UserSvg;
			case 'users':
				return UsersSvg;
			case 'video':
				return VideoSvg;
			default:
				// eslint-disable-next-line react/function-component-definition
				return () => <span />;
		}
	}, [name]);

	if (typeof size === 'number') {
		return <Component width={size} height={size} className={className} {...props} />;
	}
	if (size && Array.isArray(size)) {
		const [width, height] = size;
		return <Component width={width} height={height} className={className} {...props} />;
	}
	return <Component className={className} {...props} />;
};

export {
	arrowCircleIconSrc,
	ArrowCircleSvg,
	bookIconSrc,
	BookSvg,
	brandLinkedinIconSrc,
	BrandLinkedinSvg,
	bulbElectroIconSrc,
	BulbElectroSvg,
	bulletIconSrc,
	BulletSvg,
	calendarDateIconSrc,
	CalendarDateSvg,
	calendarScheduleIconSrc,
	CalendarScheduleSvg,
	calendarMagnifyingGlassIconSrc,
	CalendarMagnifyingGlassSvg,
	calendarFullIconSrc,
	CalendarFullSvg,
	checkSquareIconSrc,
	CheckSquareSvg,
	checklistIconSrc,
	ChecklistSvg,
	cloudMessageZigzagIconSrc,
	CloudMessageZigzagIcon,
	clockIconSrc,
	ClockSvg,
	communicationIconSrc,
	CommunicationSvg,
	contactIconSrc,
	ContactSvg,
	desktopIconSrc,
	DesktopSvg,
	downloadIconSrc,
	DownloadSvg,
	diagramSquareIconSrc,
	DiagramSquareSvg,
	envelopeIconSrc,
	EnvelopeSvg,
	eyeAltIconSrc,
	EyeAltSvg,
	eyeIconSrc,
	EyeSvg,
	fileCheckIconSrc,
	FileCheckSvg,
	checklistSquareAltIconSrc,
	ChecklistSquareAltSvg,
	checklistSquareIconSrc,
	ChecklistSquareSvg,
	goalsEvaluationIconSrc,
	GoalsEvaluationSvg,
	editSquareIconSrc,
	EditSquareSvg,
	openExternalIconSrc,
	OpenExternalSvg,
	notFoundSquareIconSrc,
	NotFoundSquareSvg,
	pdfSquareIconSrc,
	PdfSquareSvg,
	pencilSignSquareIconSrc,
	PencilSignSquareSvg,
	pencilSquareIconSrc,
	PencilSquareSvg,
	textSquareIconSrc,
	TextSquareSvg,
	textWriteSquareIconSrc,
	TextWriteSquareSvg,
	handIconSrc,
	HandSvg,
	heartIconSrc,
	HeartSvg,
	homeIconSrc,
	HomeSvg,
	identifierIconSrc,
	IdentifierSvg,
	papersIconSrc,
	PapersSvg,
	pathIconSrc,
	PathSvg,
	phoneIconSrc,
	PhoneSvg,
	questionMarkSquareIconSrc,
	QuestionMarkSquareSvg,
	questionMarkSquareAltIconSrc,
	QuestionMarkSquareAltSvg,
	settingsIconSrc,
	SettingsSvg,
	sheetIconSrc,
	SheetSvg,
	bookSquareIconSrc,
	BookSquareSvg,
	bookMagSquareIconSrc,
	BookMagSquareSvg,
	bulbElectroSquareIconSrc,
	BulbElectroSquareSvg,
	compasSquareIconSrc,
	CompasSquareSvg,
	faceSadSquareIconSrc,
	FaceSadSquareSvg,
	rocketSquareIconSrc,
	RocketSquareSvg,
	signpostSquareIconSrc,
	SignpostSquareSvg,
	sproutSquareIconSrc,
	SproutSquareSvg,
	starIconSrc,
	StarSvg,
	statsIconSrc,
	StatsSvg,
	timesSquareIconSrc,
	TimesSquareSvg,
	toolsIconSrc,
	ToolsSvg,
	trashIconSrc,
	TrashSvg,
	userPlusIconSrc,
	UserPlusSvg,
	userIconSrc,
	UserSvg,
	usersIconSrc,
	UsersSvg,
	videoIconSrc,
	VideoSvg,
};
